import { render } from "./ListGroup.vue?vue&type=template&id=07c6e388&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"

import "./ListGroup.vue?vue&type=style&index=0&id=07c6e388&scoped=true&lang=css"
import "./ListGroup.vue?vue&type=style&index=1&id=07c6e388&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c6e388"]])

export default __exports__